// A rate slider that gives the low end room (#420). Embellishments sound best
// used sparingly, and a linear 0–100% slider in 5% steps started at a rate
// that was already too much. The stored value stays a plain rate (0..1), so
// nothing persisted changes; only the slider's travel is curved: the position
// is the square root of the rate, so 1% sits a tenth of the way along, 5% a
// fifth, and each step at the bottom is a hundredth of a percent.

export const RATE_SLIDER_MAX = 100;

/** Slider position (0..RATE_SLIDER_MAX) for a stored rate. */
export function rateToSlider(rate: number): number {
  const r = Math.max(0, Math.min(1, rate));
  return Math.round(Math.sqrt(r) * RATE_SLIDER_MAX);
}

/** Stored rate for a slider position. */
export function sliderToRate(position: number): number {
  const p = Math.max(0, Math.min(RATE_SLIDER_MAX, position)) / RATE_SLIDER_MAX;
  return Math.round(p * p * 10000) / 10000;
}

/** "0.5%", "4%": a decimal only where the rate is under 1%. */
export function formatRate(rate: number): string {
  const pct = rate * 100;
  if (pct > 0 && pct < 1) return `${Math.round(pct * 100) / 100}%`;
  return `${Math.round(pct)}%`;
}
